import { Badge } from "@/components/ui/badge/badge";
import { CardType, ColumnType } from "./types";
import { Card } from "./card";

type ColumnProps = {
  title: string;
  headingColor: string;
  cards: CardType[];
  column: ColumnType;
};

export const Column = ({ title, headingColor, cards, column }: ColumnProps) => {
  const filteredCards = cards.filter((c) => c.column === column);

  return (
    <div className="w-64 shrink-0">
      <div className="mb-3 flex items-center justify-between border-b pb-2">
        <h3 className={`font-medium ${headingColor}`}>{title}</h3>

        <Badge className="font-normal" variant="outline">
          {filteredCards.length}
        </Badge>
      </div>

      <div className="h-full w-full transition-colors space-y-2">
        {filteredCards.map((c) => {
          return <Card key={c.id} cardInfo={c} />;
        })}
      </div>
    </div>
  );
};
